<div id="login" style="z-index:10; position:relative" [class.d-none]="!islogin"></div>

<main  class="main" [ngClass]="{'admin-mode': isAdmin}" data-jul-theme="jul" *ngIf="!islogin">
  <div *ngIf="isAdmin" class="administrator-container">
    <label class="administrator-label">{{'layout.label.administrator-mode' | translate }}</label>
    <label class="exit-administrator-label"
      (click)="exitAdministratorMode()">{{ 'layout.label.exit' | translate }}</label>
  </div>

  <!--<div [ngClass]="{'alert-container-admin': isAdmin, 'alert-container-regular': !isAdmin}">
    <jul-alert (alertChanges)="updateAlerts($event)" [klass]="['position-fixed']"></jul-alert>
  </div>-->
  
  <div class="alert-wrapper">
    <jul-alert (alertChanges)="updateAlerts($event)"></jul-alert>
  </div>
  
  <div>
    <app-header></app-header>
  </div>

   <router-outlet></router-outlet>
   
</main>
